import { render, staticRenderFns } from "./listOpportunities.vue?vue&type=template&id=76f3621e&scoped=true"
import script from "./listOpportunities.vue?vue&type=script&lang=js"
export * from "./listOpportunities.vue?vue&type=script&lang=js"
import style0 from "./listOpportunities.vue?vue&type=style&index=0&id=76f3621e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f3621e",
  null
  
)

export default component.exports